import React from 'react'
import { Link } from 'react-router-dom'
import BuyCoinModal from './BuyCoinModal'

const AddCoin = ({userData}) => {
    const [showModal, setShowModal] = React.useState(false);
    const [buyInfo, setBuyInfo] = React.useState({});
    const menu = [
        {
            price: 600,
            coin: 20,
            text: "3～5人のお試しゲームに"
        },
        {
            price: 1200,
            coin: 50,
            text: "6～10人の小規模ゲームに",
            save: "￥300 お得！"
        },
        {
            price: 2200,
            coin: 100,
            text: "15～20人の中規模ゲームに",
            save: "￥800 お得！"
        },
        {
            price: 4000,
            coin: 200,
            text: "30人以上の大規模ゲームや、複数回の小規模利用に",
            save: "￥2,000 お得！",
            suggest: true
        },
        {
            price: 7000,
            coin: 400,
            text: "50人以上の超大規模ゲームや、複数回の利用に",
            save: "￥5,000 お得！"
        },
    ]

    return (
        <div className='p-3 max-w-3xl mx-auto pt-6 mb-3'>
            <h1 className='text-3xl text-center mb-6'><i className="bi bi-coin me-2"></i>クレジットの管理</h1>

            {/* コイン残高 */}
            <div className='bg-white shadow p-4 rounded-lg mb-8 max-w-lg mx-auto'>
                <h2 className='text-xl mb-3 text-gray-700'><i className='bi bi-coin me-2'></i>クレジット残高</h2>
                <p className='text-3xl text-purple-600 text-center font-medium mb-4'>{Number(userData.coin).toLocaleString()} pt</p>
                <Link to='/account/addCoin/history' className='block text-center text-gray-600 p-1 rounded-md border hover:bg-gray-50'><i className='bi bi-clock-history me-2'></i>購入履歴</Link>
            </div>
            
            {/* 料金表 */}
            <h2 className='text-center text-xl text-gray-600 mb-3 tracking-widest'>クレジットを購入</h2>

            {/* 消費量の説明 */}
            <div className='bg-white shadow-sm p-4 rounded-lg mb-6 max-w-lg mx-auto text-sm text-gray-600'>
                <p><i className='bi bi-info-circle text-purple-500 me-2'></i>ゲームをアクティベートする際、<span className='font-medium'>「参加人数 × ゲーム時間(時間)」</span>のクレジットを消費します（1人×1時間＝1pt、端数は切り上げ）。</p>
                <p className='mt-1 text-gray-500'>例: 10人で3時間のゲームを実行する場合 → 30pt</p>
            </div>

            <div className='grid lg:grid-cols-3 grid-cols-2 gap-3'>
                {
                    menu.map((item, index) => (
                        <div key={index} className={'rounded-lg bg-white px-4 py-6 shadow-sm relative ' + (item.suggest ? 'border-2 border-purple-500' : 'border border-purple-300')}>
                            <div className='relative h-full'>
                                <h3 className='text-2xl text-center mb-4 text-purple-600 font-medium'>{item.coin}pt</h3>
                                <p className='text-gray-500 text-sm'>{item.text}</p>
                                <hr className='my-3' />
                                <p className='text-2xl my-2 text-gray-800 text-center font-medium'>￥{item.price.toLocaleString()}</p>
                                {item.save && <p className='text-base text-lime-600 mb-12'>{item.save}</p>}

                                <button className='bg-purple-500 hover:bg-purple-600 text-white p-2 px-6 rounded-md block mt-4 shadow-sm tracking-widest absolute -bottom-1 w-full' onClick={() => {setBuyInfo({coin: item.coin, price: item.price});setShowModal(true)}}>購入</button>
                            </div>

                            {item.suggest && <div className='absolute shadow -top-2 -end-3 bg-purple-500 text-white p-1 px-2 rounded-lg'>おすすめ</div>}
                        </div>
                    ))
                }
            </div>

            <BuyCoinModal isOpen={showModal} onClose={() => setShowModal(false)} coin={buyInfo.coin} price={buyInfo.price} uid={userData.uid} />
        </div>
    )
}

export default AddCoin